import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import { paths } from "../../paths/paths";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import moment from "moment";
import "moment/locale/ar";
import { useEffect, useState } from "react";
import Lang from "../../userPreferences/staticWords";
import TaskComments from "./taskComments";
import { resolver } from "../../API/middlewares/resolveRequests";
import ModalComponent from "../reusableComponents/modal";
import EditProcForm from "./editProc.js/editProcForm";
import { procData as ProcData } from "../../API/store/actions/procedure/procedure";
import AddTaskAttachments from "./addTaskAttachmentPopup";
import EditProcStatus from "./editProcStatus/procStatus";
import { formatDateLL } from "../../algorithms";
import DeleteProcAlert from "./editProc.js/deleteProc";
import { useSelector } from "react-redux";
import AttachmentsPopup from "./attachmentsPopup";
import Titlebar from "./../layout/titlebar";
import { Link } from "react-router-dom";
import SubTaskComments from "./subTaskComments";
import ReactTooltip from "react-tooltip";
import { editSubTaskData, SubTaskDataAdd } from "../../API/store/actions/tasks";
import EditSubTaskForm from "./subTask/editSubTask";
import CommentSection from "./subTaskComments/CommentSection";
import AddProcedureForm from "./addProcedure/addProcedureForm";
import AddCommentForm from "./subTaskComments/AddCommentForm";

const SuBTasksCard = (props) => {
  const userToken = useSelector((state) => state.login.userToken);

  const [show, setshow] = useState({ id: null, display: false });
  const [data, setData] = useState(null);
  const [VisibleEditProc, setVisibleEditProc] = useState(false);
  const [VisibleEditProcStatus, setVisibleEditProcStatus] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [subTaskTitle, setSubTaskTitle] = useState(null);
  const [subTaskId, setSubTaskId] = useState(null);
  const [visibleEdit, setVisibleEdit] = useState(false);

  const [showAttachmentPopup, setShowAttachmentPopup] = useState(false);

  const [visibleProc, setVisibleProc] = useState(false);

  const { setProcAdded, procAdded, subTasks } = props;
  const communityId = useSelector((state) => state.community.communityId?.id);
  const community = useSelector((state) => state.community.communityId);

  const onShowAttachments = () => {
    setShowAttachmentPopup(true);
  };
  const renderAttachmentsModal = () => {
    return (
      <AddTaskAttachments
        procAdded={procAdded}
        setProcAdded={setProcAdded}
        subTaskId={subTaskId}
        show={showAttachmentPopup}
        onHide={() => setShowAttachmentPopup(false)}
      />
    );
  };

  useEffect(() => {
    if (Lang.getLanguage() === "ar") moment.locale("ar");
    else moment.locale("en");
    if (data) setVisibleEditProc(true);
  }, [data]);

  const [showTaskAttachmentsPopup, setshowTaskAttachmentsPopup] =
    useState(false);
  const [taskAttachmentsContent, settaskAttachmentsContent] = useState([]);

  const onshowTaskAttachmentsPopup = () => {
    setshowTaskAttachmentsPopup(true);
  };

  const [proc, setProc] = useState({});

  const renderTaskAttachmentsModal = (attachments) => {
    return (
      <AttachmentsPopup
        isActivity={false}
        name={proc.description}
        content={attachments}
        show={showTaskAttachmentsPopup}
        onHide={() => setshowTaskAttachmentsPopup(false)}
      />
    );
  };

  window.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menu-task")}`,
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshow({ id: null, display: false });
        }
      }
    }
  };

  useEffect(() => {
    if (data) setVisibleEdit(true);
  }, [data]);

  if (subTasks)
    return (
      <>
        <ModalComponent
          body={
            <DeleteProcAlert
              userToken={userToken}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              subTaskId={subTaskId}
              setVisible={setDeleteModalVisible}
              content={"هل تريد حذف الإجراء الفرعي وملحقاته ؟"}
            />
          }
          size={"s"}
          modalVisible={deleteModalVisible}
          setModalVisible={setDeleteModalVisible}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />
        <ModalComponent
          body={
            <EditSubTaskForm
              subTaskTitle={subTaskTitle}
              subTaskId={subTaskId}
              setVisible={setVisibleEdit}
              data={data?.data}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              userToken={userToken}
            />
          }
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleEdit}
          modalVisible={visibleEdit}
          size={"xl"}
          title={"تعديل الإجراء الفرعي"}
        />

        {/* <ModalComponent
          body={
            <TaskStatus
              userToken={userToken}
              subTaskTitle={subTaskTitle}
              taskId={taskId}
              setVisible={setVisibleStatus}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          }
          hasImage={
            <img
              src="/assets/images/icons/status.png"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleStatus}
          modalVisible={visibleStatus}
          size={"xl"}
          title={"تغيير حالة الإجراء"}
        /> */}
        <ModalComponent
          body={
            <AddCommentForm
              userToken={userToken}
              taskprocedureId={subTaskId}
              setVisible={setVisibleProc}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          }
          hasImage={
            <div
              style={{
                backgroundColor: "#1A73E8",
                height: 26,
                width: 26,
                cursor: "pointer",
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center itemNav plusIcon"
            >
              <div
                style={{
                  width: 16,
                  height: 16,
                  background:
                    "url('/assets/images/icons/Path 184.png') 0% 0% no-repeat padding-box",
                  opacity: 1,
                  filter: "opacity(1) brightness(20)",
                }}
                className="any"
              ></div>
            </div>
          }
          setModalVisible={setVisibleProc}
          modalVisible={visibleProc}
          size={"xl"}
          title={Lang.addProcedure}
        />
        {/* <Titlebar
          title={"الإجراءات الفرعية"}
          containerStyle={"px-xl-5 px-0"}
          customImage="/assets/images/icons/Group 250.png"
        /> */}
        {subTasks?.map((procedure, index) => {
          return (
            <span
              key={index + parseInt(procedure.id) * 0.3}
              style={{
                borderBottom: "2px solid rgba(53, 132, 234, 0.5)",
              }}
            >
              <div className="mt-4">
                <div className="d-flex flex-column px-md-5 px-4 mx-4 align-items-center">
                  <div className="d-flex align-items-start col-12 justify-content-start my-2 px-3 px-md-0">
                    <Link
                      className={`my-0 ${styleEnd(
                        "m",
                        3,
                      )} text-decoration-none text-dark`}
                      style={{
                        lineHeight: 1.5,
                        fontSize: 18,
                        fontWeight: "bold",
                      }}
                      // to={`/subTaskDetails/${procedure.id}`}
                      to=""
                    >
                      {procedure.name}
                    </Link>
                    <div className="col d-flex justify-content-end align-items-end btn-group">
                      {show.id == procedure.id ? (
                        <>
                          <div
                            style={{ display: show.display ? "block" : "none" }}
                            className={`${customStyle(
                              "arrow-horizontal-task",
                            )} ${show.display ? "show" : ""}`}
                          ></div>
                          <ul
                            className={`${customStyle("dropdown-menu-task")} ${
                              show.display ? "show" : ""
                            }`}
                            style={{
                              display: show.display ? "block" : "none",
                            }}
                          >
                            <li
                              style={{ cursor: "pointer" }}
                              id={procedure.id}
                              onClick={(e) => {
                                const currentId = e.currentTarget.id;
                                resolver(
                                  editSubTaskData,
                                  setData,
                                  currentId,
                                  communityId,
                                  userToken,
                                );
                                setSubTaskId(currentId);
                              }}
                            >
                              <span
                                className={`dropdown-item ${customStyle(
                                  "dropdown-item",
                                )}`}
                              >
                                تعديل الإجراء الفرعي
                              </span>
                            </li>
                            <li
                              style={{ cursor: "pointer" }}
                              id={procedure.id}
                              onClick={(e) => {
                                const currentId = e.currentTarget.id;
                                setSubTaskId(currentId);
                                onShowAttachments();
                              }}
                            >
                              <span
                                className={`dropdown-item ${customStyle(
                                  "dropdown-item",
                                )}`}
                              >
                                اضافة مرفقات
                              </span>
                            </li>
                            {/* <li
                              style={{ cursor: "pointer" }}
                              id={procedure.id}
                              onClick={(e) => {
                                const currentId = e.currentTarget.id;
                                setSubTaskId(currentId);
                                setDeleteModalVisible(true);
                              }}
                            >
                              <span
                                className={`dropdown-item ${customStyle(
                                  "dropdown-item",
                                )}`}
                              >
                                حذف الإجراء الفرعي
                              </span>
                            </li> */}
                          </ul>
                        </>
                      ) : null}
                    </div>

                    {community?.adminTask && (
                      <Icon
                        id={procedure.id}
                        name="ellipsis-v"
                        size={18}
                        className=" d-flex icon"
                        style={{ display: "block" }}
                        onclick={(e) => {
                          const id = e.currentTarget.id;
                          id == null
                            ? setshow({
                                id,
                                display: true,
                              })
                            : id == show.id
                              ? setshow({
                                  id: null,
                                  display: false,
                                })
                              : setshow({
                                  id,
                                  display: true,
                                });
                        }}
                      />
                    )}
                  </div>
                  <div className="d-flex align-items-center col-md col-12 my-2">
                    <div
                      style={{ fontSize: 14, color: "#444444" }}
                      className=""
                    >
                      {Lang.inPeriod}
                      <span>
                        &nbsp;&nbsp;{Lang.from}&nbsp;
                        {`${formatDateLL(procedure.startDate)}`}
                      </span>
                      <span>
                        &nbsp;&nbsp;{Lang.to}&nbsp;
                        {`${formatDateLL(procedure.endDate)}`}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {procedure?.member?.length && (
                <div className="mx-4 px-4 px-md-5">
                  <span className="ms-2">الجهات المسؤلة :</span>
                  <span>
                    {procedure?.member
                      ?.map((member) => member.memberName)
                      .join(",  ")}
                  </span>
                </div>
              )}

              <div
                // style={{
                //   borderBottom: "2px solid rgba(53, 132, 234, 0.5)",
                // }}
                className="d-flex flex-wrap align-items-center justify-content-around mx-5 py-2"
              >
                {procedure?.dayCount?.daystatus ? (
                  <div
                    className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                      "m",
                      2,
                    )} mb-2`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: 160,
                      borderRadius: 10,
                    }}
                  >
                    <div className={`${styleEnd("m", 2)}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.883"
                        height="18"
                        viewBox="0 0 16.883 18"
                      >
                        <path
                          id="_001-clock"
                          data-name="001-clock"
                          d="M8.442,18.25C.949,18.242-2.821,8.53,2.473,2.871a8.107,8.107,0,0,1,11.938,0C19.7,8.531,15.934,18.242,8.442,18.25Zm0-16.61a7.382,7.382,0,0,0-7.123,7.6c.391,10.084,13.855,10.081,14.245,0A7.382,7.382,0,0,0,8.442,1.64Zm3.071,9.884L9.429,9.3A1.092,1.092,0,0,0,9.1,8.454c0-.007,0-.015,0-.022V4.314a.661.661,0,1,0-1.319,0V8.432c0,.007,0,.015,0,.022A1.066,1.066,0,0,0,8.5,10.3l2.084,2.224a.631.631,0,0,0,.933,0,.738.738,0,0,0,0-1Z"
                          transform="translate(0 -0.25)"
                          fill={procedure?.dayCount?.color ?? "#3ec4b8"}
                        />
                      </svg>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <p className="my-0">
                        {procedure?.dayCount?.day >= 0
                          ? procedure?.dayCount?.day
                          : ""}
                        &nbsp;
                        {procedure?.dayCount?.daystatus}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div
                    className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                      "m",
                      2,
                    )} mb-2`}
                    style={{ width: 160 }}
                  ></div>
                )}

                {procedure?.taskStatus?.name ? (
                  <div
                    className={`d-flex justify-content-center py-2 px-3 mb-2`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: 160,
                      borderRadius: 10,
                    }}
                  >
                    <div className={`${styleEnd("m", 2)}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                      >
                        <g
                          id="technical-support_1_"
                          data-name="technical-support (1)"
                          transform="translate(0 0.001)"
                        >
                          <path
                            id="Path_428"
                            data-name="Path 428"
                            d="M3.165,13.919a1.468,1.468,0,0,0-.709.181A8.3,8.3,0,0,1,10.652.867a.352.352,0,0,0,.139-.689A9.067,9.067,0,0,0,9,0,9,9,0,0,0,1.936,14.577a1.477,1.477,0,1,0,1.229-.658Zm.547,2.023a.773.773,0,1,1,.227-.547A.768.768,0,0,1,3.712,15.943Zm0,0"
                            transform="translate(0)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_429"
                            data-name="Path 429"
                            d="M206.6,34.346a1.473,1.473,0,1,0-.52.477,8.3,8.3,0,0,1-8.18,13.236.352.352,0,1,0-.138.69,9.073,9.073,0,0,0,1.775.175A9,9,0,0,0,206.6,34.346Zm-1.776-.272a.774.774,0,1,1,.547.226A.768.768,0,0,1,204.828,34.074Zm0,0"
                            transform="translate(-190.541 -30.925)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_430"
                            data-name="Path 430"
                            d="M78.932,86.445a.352.352,0,0,0,.352.352h2.2a.352.352,0,0,0,.352-.352v-.682a5.505,5.505,0,0,0,1.319-.547l.481.481a.351.351,0,0,0,.5,0l1.554-1.555a.352.352,0,0,0,0-.5l-.481-.481a5.5,5.5,0,0,0,.547-1.319h.679a.352.352,0,0,0,.352-.352V79.3a.352.352,0,0,0-.352-.352h-.679a5.505,5.505,0,0,0-.547-1.319l.478-.478a.352.352,0,0,0,0-.5L84.127,75.1a.352.352,0,0,0-.5,0l-.477.477a5.5,5.5,0,0,0-1.319-.547v-.675A.352.352,0,0,0,81.482,74h-2.2a.352.352,0,0,0-.352.352v.675a5.5,5.5,0,0,0-1.319.547l-.477-.477a.352.352,0,0,0-.5,0L75.084,76.65a.351.351,0,0,0,0,.5l.478.478a5.5,5.5,0,0,0-.547,1.319h-.678a.352.352,0,0,0-.352.351v2.2a.351.351,0,0,0,.352.352h.679a5.506,5.506,0,0,0,.547,1.319l-.481.481a.352.352,0,0,0,0,.5L76.635,85.7a.352.352,0,0,0,.249.1h0a.352.352,0,0,0,.249-.1l.481-.481a5.51,5.51,0,0,0,1.319.547Zm-1.182-1.968a.352.352,0,0,0-.439.047l-.428.428-1.057-1.058.428-.428a.351.351,0,0,0,.047-.439,4.812,4.812,0,0,1-.666-1.607.352.352,0,0,0-.344-.278h-.6v-1.5h.6a.352.352,0,0,0,.344-.278,4.812,4.812,0,0,1,.666-1.607.351.351,0,0,0-.047-.439l-.425-.425,1.058-1.057.424.425a.352.352,0,0,0,.439.047,4.81,4.81,0,0,1,1.607-.666.352.352,0,0,0,.278-.344v-.6h1.5v.6a.351.351,0,0,0,.278.344,4.814,4.814,0,0,1,1.607.666.351.351,0,0,0,.439-.047l.425-.424L84.937,76.9l-.425.425a.351.351,0,0,0-.047.439,4.815,4.815,0,0,1,.666,1.607.351.351,0,0,0,.344.278h.6v1.5h-.6a.352.352,0,0,0-.344.278,4.811,4.811,0,0,1-.666,1.607.352.352,0,0,0,.047.439l.428.428-1.057,1.058-.428-.428a.351.351,0,0,0-.439-.047,4.815,4.815,0,0,1-1.607.666.352.352,0,0,0-.278.344v.607h-1.5v-.607a.352.352,0,0,0-.278-.344A4.812,4.812,0,0,1,77.751,84.477Zm0,0"
                            transform="translate(-71.384 -71.399)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_431"
                            data-name="Path 431"
                            d="M179.181,176.276a2.9,2.9,0,1,0-2.9,2.9A2.908,2.908,0,0,0,179.181,176.276Zm-5.107,0a2.2,2.2,0,1,1,2.2,2.2A2.2,2.2,0,0,1,174.074,176.276Zm0,0"
                            transform="translate(-167.277 -167.277)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_432"
                            data-name="Path 432"
                            d="M338.43,18.512a.352.352,0,1,0-.248-.1A.354.354,0,0,0,338.43,18.512Zm0,0"
                            transform="translate(-326.193 -17.183)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_433"
                            data-name="Path 433"
                            d="M154.711,474.359a.352.352,0,1,0,.249.1A.355.355,0,0,0,154.711,474.359Zm0,0"
                            transform="translate(-148.933 -457.683)"
                            fill={procedure?.taskStatus?.color}
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <p className="my-0">{procedure?.taskStatus?.name}</p>
                    </div>
                  </div>
                ) : (
                  <div
                    className={`d-flex justify-content-center py-2 px-3 mb-2`}
                    style={{
                      width: 160,
                      borderRadius: 10,
                    }}
                  ></div>
                )}

                {procedure?.procedureCount ? (
                  <div
                    className="d-flex justify-content-center py-2 px-3 mb-2 text-decoration-none text-dark"
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: 160,
                      borderRadius: 10,
                    }}
                  >
                    <div className=" d-flex">
                      <div
                        className={`d-flex justify-content-center align-items-center ${styleEnd(
                          "m",
                          2,
                        )}`}
                        style={{
                          border: "1px solid #1A73E8",
                          backgroundColor: "#1A73E8",
                          color: "white",
                          borderRadius: "50%",
                          width: 24,
                          height: 24,
                          fontSize: 12,
                        }}
                      >
                        {procedure?.procedureCount}
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">
                          {procedure?.procedureCount > 1
                            ? Lang.procedures
                            : Lang.procedure}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="d-flex justify-content-center py-2 px-3 mb-2 text-decoration-none text-dark"
                    style={{
                      width: 160,
                    }}
                  ></div>
                )}

                {procedure?.memberCount ? (
                  <div
                    className={`d-flex py-2 px-3 mb-2 text-decoration-none text-dark ${styleStart(
                      "m",
                      2,
                    )}`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: 160,
                      height: 40,
                      borderRadius: 10,
                    }}
                  >
                    <li
                      className="d-flex justify-content-center"
                      style={{
                        width: "inherit",
                      }}
                      data-tip
                      data-for={customStyle(`liMembers-${procedure.id}`)}
                    >
                      <ReactTooltip
                        id={customStyle(`liMembers-${procedure.id}`)}
                        type="info"
                        effect="solid"
                        place={"top"}
                        backgroundColor="#12AAC4"
                        arrowColor="#12AAC4"
                      >
                        <span>
                          {procedure?.members?.length ? (
                            procedure?.members?.map((item, index) => {
                              return (
                                <div>
                                  {item.memberName}
                                  <br />
                                </div>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </span>
                      </ReactTooltip>
                      <div
                        className={`d-flex justify-content-center align-items-center ${styleEnd(
                          "m",
                          2,
                        )}`}
                        style={{
                          border: "1px solid #1A73E8",
                          backgroundColor: "#1A73E8",
                          color: "white",
                          borderRadius: "50%",
                          width: 24,
                          height: 24,
                          fontSize: 12,
                        }}
                      >
                        {procedure.memberCount ?? 0}
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">
                          {procedure.memberCount > 1
                            ? Lang.Members
                            : Lang.Member}
                        </p>
                      </div>
                    </li>
                  </div>
                ) : (
                  <div
                    className={`d-flex py-2 px-3 mb-2 text-decoration-none text-dark ${styleStart(
                      "m",
                      2,
                    )}`}
                    style={{ width: 160 }}
                  ></div>
                )}
              </div>
              <div className="col-12 mx-4 px-4 px-md-5 py-2 mb-2">
                <div className="text-muted mb-2">المرفقات</div>

                {procedure.attchment?.length > 0 ? (
                  <div className="d-flex  gap-2">
                    {procedure.attchment.map((file) => (
                      <a
                        key={file.id}
                        href={`${paths.SubTaskAttachments}${file.id}/${file.attachment}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none text-dark d-flex gap-2"
                      >
                        <Icon name="paperclip" size={14} />
                        <span className="mx-2">{file.attachment}</span>
                      </a>
                    ))}
                  </div>
                ) : (
                  <span className="text-muted">لا يوجد</span>
                )}
              </div>
              <CommentSection
                items={procedure?.procedure}
                procedureCount={procedure?.procedure.length}
                lang={Lang}
                onAddComment={(taskId) => {
                  setSubTaskId(procedure?.id);
                  setVisibleProc(true);
                }}
              />

              {/* {props.commentsUnderProcedure &&
              props.displayComments.id == procedure.id ? (
                <SubTaskComments
                  commentsUnderProcedure={props.commentsUnderProcedure}
                  subTasks={subTasks}
                  displayComments={props.displayComments}
                  setDisplayComments={props.setDisplayComments}
                />
              ) : null} */}
            </span>
          );
        })}
        {renderAttachmentsModal(subTaskId)}
        {/* {renderTaskAttachmentsModal()} */}
      </>
    );
  return <></>;
};

export default SuBTasksCard;
